import React, { FC } from 'react'
import { Row } from 'reactstrap'

export const StaticRow: FC = props => <Row className="m-b-15">{props.children}</Row>
